import { type UseQueryResult, useQuery } from 'react-query';
import {
  CustomerSuccessService,
  PagedResultDto_CompanyMappingResponseDto,
} from '@wealthlane/api-services/wealthlane-customer-service';
import { TableParamsType } from '../../types/common';

const useGetAllAllowedCompanyMapping = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<PagedResultDto_CompanyMappingResponseDto | undefined, unknown> => {
  const { filter, sorting, skipCount, maxResultCount } = tableInfo;
  return useQuery(
    ['getAllAllowedCompanyMappings', filter, sorting, skipCount, maxResultCount],
    async () => {
      return await handleRequest(
        CustomerSuccessService.getApiCustomerApiCustomerCustomerSuccessAllowedCompanyMappings(
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );
};

export default useGetAllAllowedCompanyMapping;
